import { render, staticRenderFns } from "./fan-view-page.vue?vue&type=template&id=6dcf4597&"
import script from "./fan-view-page.vue?vue&type=script&lang=js&"
export * from "./fan-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports